import React, { Component } from "react";
import ParticlesBg from "particles-bg";
import "./welcomeHeader.css";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import More from "./More";
import Submenu from "./Submenu";
import Hero from "./Hero";

class Header extends Component {
  render() {
    return (
      <header className="header_welcome">
        <Navbar />
        <Sidebar />
        <Hero />
        <Submenu />
        <More />
        <ParticlesBg type="thick" bg={true} />
      </header>
    );
  }
}

export default Header;
